"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react');

var _actionCreators = require('shared/actions/actionCreators'); var _actionCreators2 = _interopRequireDefault(_actionCreators);
var _bus = require('shared/services/bus'); var _bus2 = _interopRequireDefault(_bus);

const relevantActionTypes = [
  _actionCreators2.default.addUsersToTeamActions.SUCCESS.type,
  _actionCreators2.default.removeUserFromTeamActions.SUCCESS.type,
]

 const useTeamMembersListListener = (listener) => {
  _react.useEffect.call(void 0, 
    () => {
      relevantActionTypes.forEach(t => _bus2.default.on(t, listener))
      return () => relevantActionTypes.forEach(t => _bus2.default.off(t, listener))
    },
    [listener],
  )
}; exports.useTeamMembersListListener = useTeamMembersListListener
